import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import OrderSettingSummary from './OrderSettingSummary';
import ParentChildSettingSummary from '../../ParentChildRefactor/components/OrderSettingSummary';
import * as actions from '../orderSettingActions';
import { PICKUP } from '../orderSettingTypes';
import appConfig from '../../../../app-config';

let OrderSettingSummaryContainer = ({
  isForReviewPage,
  notEditable,
  currentLocation,
  hideToolTip,
  updateOrderSettingModalIsVisible,
  orderSettingReducer,
  locations,
  cartMenuSidebar,
  selectedDropOffLocation,
}) => {
  const {
    interPickUpDetails,
    orderType,
    interOrderType,
    interDeliveryDetails,
    interSelectedDateTime,
    toolTipIsHidden,
    dateTimeToShow,
    specialHours,
    parentLocation,
    dropOffDetails,
    selectedLocation,
  } = orderSettingReducer;

  const [nearestLocation, setNearestLocation] = useState(null);

  useEffect(() => {
    if (currentLocation && locations) {
      setNearestLocation(
        locations.find(
          (location) =>
            location.accepting_orders &&
            location.is_order_ahead_enabled &&
            location.accepted_order_types.includes(PICKUP)
        )
      );
    } else {
      setNearestLocation(null);
    }
  }, [locations, currentLocation]);

  if (
    interPickUpDetails ||
    nearestLocation ||
    interDeliveryDetails ||
    dropOffDetails ||
    dropOffDetails
  )
    return (
      <OrderSettingSummary
        notEditable={notEditable}
        nearestLocation={nearestLocation}
        hideToolTip={hideToolTip}
        toolTipIsHidden={toolTipIsHidden}
        isForReviewPage={isForReviewPage}
        updateOrderSettingModalIsVisible={updateOrderSettingModalIsVisible}
        interPickUpDetails={interPickUpDetails || nearestLocation}
        deliveryDetails={interDeliveryDetails}
        dateTimeToShow={dateTimeToShow}
        orderType={orderType}
        specialHours={specialHours}
        dropOffDetails={dropOffDetails}
        selectedDropOffLocation={selectedDropOffLocation}
        parentLocation={parentLocation}
        interSelectedDateTime={interSelectedDateTime}
      />
    );
  else return null;
};

const mapStateToProps = (state) => ({
  currentLocation: state.locationsReducer.currentLocation,
  orderSettingReducer: state.orderSettingReducer,
  locations: state.locationsReducer.locations,
  selectedDropOffLocation: state.dropOffLocationReducer.selectedDropOffLocation,
});

export default connect(mapStateToProps, actions)(OrderSettingSummaryContainer);
